import type { FooterSlotClaim } from './atoms'

/**
 * Compare-and-clear for the footer's single bottom slot: a holder gives the
 * slot back only while it still holds it.
 *
 * Holders overlap. The view router animates a view out (`AnimatePresence` plus
 * the swap spring), so the outgoing Meeting View stays mounted — and its claim
 * cleanup stays pending — for the whole swap, while the floating bar's meeting
 * cluster mounts and claims the slot on the swap's first frame. An
 * unconditional release then lands last and clears a claim it never made.
 *
 * That is what took the notepad off screen on navigation while
 * `meetingNotepadModeAtom` still read as open: the toggle went on offering
 * "Chat", so its next press closed an already-closed notepad and only the one
 * after it re-opened (HIG-6010).
 *
 * Its own module, with a type-only import of the atom, so it stays testable —
 * `atoms.ts` reaches for renderer-only globals.
 */
export function releaseFooterSlotClaim(owner: object) {
  return (current: FooterSlotClaim | null): FooterSlotClaim | null => (current?.owner === owner ? null : current)
}
